import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpStatusCode,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const unauthenticatedInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === HttpStatusCode.Unauthorized) {
        router.navigate(['/login']);
        return throwError(() => error);
      }

      if (error.status === HttpStatusCode.Forbidden) {
        router.navigate(['/unauthorized']);
        return throwError(() => error);
      }

      return throwError(() => error);
    }),
  );
};
